import useAuth from '../../../../hooks/auth-hooks';

/**
 * Displays a widget on the individual customer form page that shows
 * no card groups have been assigned to the customer.
 * 
 * @param {string} id the customer id
 * @param {string} name the customers name.
 * 
 * @returns void
 */
const DisplayCGNotFound = (id: string, name: string) => {
  const { accessType } = useAuth()!;

  const container = document.querySelector('.aafp_side-form-container') as HTMLElement;

  const containerDiv = document.createElement('div');
  containerDiv.className = 'aafp_terminal-card aafp_border-radius';

  const headerEle = document.createElement('h3');
  headerEle.textContent = 'Card Groups';

  const bodyContainer = document.createElement('div');
  bodyContainer.className = 'aafp_terminal-card-group';

  const cardBody = document.createElement('div');
  cardBody.className = 'aafp_terminal-card-group-body';

  const bodyContentText = accessType === 'E' 
            ? `There are no Card Groups setup for ${name}. Please follow the link below to add one.` 
            : `There are no Card Groups setup for ${name}.`;
  const bodyContent = document.createElement('span');
  bodyContent.textContent = bodyContentText;

  const cardFooter = document.createElement('div');
  cardFooter.className = 'aafp_terminal-card-group-footer';

  const cardLink = document.createElement('a');
  cardLink.className = 'aafp_btn-form btn_theme-primary';
  cardLink.href = `/new-card-group/?groupAction=add&customerID=${id}`;
  cardLink.textContent = 'SETUP';

  containerDiv.appendChild(headerEle);
  containerDiv.appendChild(bodyContainer);
  bodyContainer.appendChild(cardBody);
  cardBody.appendChild(bodyContent);
  bodyContainer.appendChild(cardFooter);
  if ( accessType === 'E' ) {
    cardFooter.appendChild(cardLink);
  }
  
  container.appendChild(containerDiv);
}

export default DisplayCGNotFound;